import { isUserLogin } from '@eureka/utils/account'
export async function getCoreTelecomApiUrlPrefix() {
    if (import.meta.env.DEV) {
        const useLocalApi = false;
        if (useLocalApi) {
            return 'http://127.0.0.1:8080/telecom';
        }
    }
    const isLogin = await isUserLogin()
    const VITE_CORE_SEARCH_SERVICE_URI = import.meta.env.VITE_CORE_SEARCH_SERVICE_URI
    if (!isLogin) {
        return `${VITE_CORE_SEARCH_SERVICE_URI}/public-share/telecom`;
    }
    return `${VITE_CORE_SEARCH_SERVICE_URI}/core-telecom-api/telecom`;
}
